export const APPS_DATA_REQUESTS = {
  WELLS: 'WELLS',
  RIGS: 'RIGS',
  FRAC_FLEETS: 'FRAC_FLEETS',
  FRAC_FLEET_WELLS: 'FRAC_FLEET_WELLS',
  PAD_WELLS: 'PAD_WELLS',
  INTERVENTION_UNITS: 'INTERVENTION_UNITS',
  INTERVENTION_UNIT_WELLS: 'INTERVENTION_UNIT_WELLS',
};
